import React from "react";
import {
  dateFromNow,
  isInFutureDateStrict,
  isInPastDateStrict,
  niceAge,
  niceDate,
  niceDateTime,
} from "../fns/util";
import { inject, observer } from "mobx-react";
import _ from "lodash";

import MasterGrid from "./MasterGrid";
import { nanoid } from "nanoid";

class ColumnDefs extends React.Component {
  sxBookingReportColumnDefs = [
    {
      headerName: "Patient",
      children: [
        {
          headerName: "Patient ID",
          field: "patientGenericPid",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
        },
        {
          headerName: "Patient Name",
          field: "patientName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.patientName;
          },
          // valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Patient Phone",
          field: "patientPhone",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.patientPhone.toString();
          },
          // valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Patient Sex",
          field: "patientSex",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.patientSex;
          },
        },
        {
          headerName: "Patient Age",
          field: "patientDob",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
          valueGetter: (params) => {
            if (!params.data) return "";

            return niceAge(params.data.patientDob);
          },
          // valueFormatter: (params) => niceAge(params.value),
        },
        {
          headerName: "Patient DoB",
          field: "patientDob",
          filter: "agDateColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          chartDataType: "time",
          valueGetter: (params) => {
            if (!params.data) return "";
            return niceDate(params.data.patientDob);
          },
          valueFormatter: (params) => niceDate(params.value),
          filterParams: {
            comparator: function (filterDates, cellValue) {
              let date = new Date(cellValue);
              let isPast = isInPastDateStrict(date, filterDates);
              let isFuture = isInFutureDateStrict(date, filterDates);
              if (isPast) {
                return -1;
              } else if (isFuture) {
                return 1;
              } else {
                return 0;
              }
            },
          },
        },
      ],
    },
    {
      headerName: "Surgeon Details",
      children: [
        {
          headerName: "Surgeon",
          field: "surgeonName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.surgeonName;
          },
          // valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Anaesthetist",
          field: "anaesthetistName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.anaesthetistName;
          },
          // valueFormatter: (params) => this.formatText(params.value),
        },
      ],
    },
    {
      headerName: "Surgery Details",
      children: [
        {
          headerName: "Surgery ID",
          field: "_id",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
        },
        {
          headerName: "Eye",
          field: "eye",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.eye;
          },
          // valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Surgery",

          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.surgeryName;
          },
        },
        {
          headerName: "Items needed in Surgery",

          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return this.niceItemsUsedString(params);
          },
        },
        {
          headerName: "Anaesthesia",
          field: "anaesthesiaType",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.anaesthesiaType;
          },
        },
        {
          headerName: "Remarks",
          field: "bookingRemarks",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.bookingRemarks;
          },
        },
        {
          headerName: "Site",
          field: "site",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.site;
          },
        },

        {
          headerName: "Diet",
          field: "diet",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.diet;
          },
        },
        {
          headerName: "Time",
          field: "time",
          filter: "agDateColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          chartDataType: "time",

          valueGetter: (params) => {
            if (!params.data) return "";
            return niceDateTime(params.data.time);
          },
          valueFormatter: (params) => niceDateTime(params.value),
          filterParams: {
            comparator: function (filterDates, cellValue) {
              let date = new Date(cellValue);
              let isPast = isInPastDateStrict(date, filterDates);
              let isFuture = isInFutureDateStrict(date, filterDates);
              if (isPast) {
                return -1;
              } else if (isFuture) {
                return 1;
              } else {
                return 0;
              }
            },
          },
        },
        {
          headerName: "Lifecycle",
          field: "lifecycle",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.lifecycle;
          },
        },
        {
          headerName: "Referred By",
          field: "referringSurgeonName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.referringSurgeonName;
          },
        },
        {
          headerName: "Patient Choice",
          field: "didPatientChooseSurgeon",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.didPatientChooseSurgeon;
          },
        },
        {
          headerName: "Emergency",
          field: "isEmergency",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.isEmergency;
          },
        },
      ],
    },
    {
      headerName: "Payment Details",
      children: [
        {
          headerName: "Bill Amount",
          field: "totalBillAmountPaise",
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
          valueGetter: (params) =>
            Math.trunc(params.data.totalBillAmountPaise) / 100,
          valueFormatter: (params) => this.formatCurrencyV2(params),
        },
        {
          headerName: "Cashless",
          field: "totalCashlessAmountPaise",
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
          valueGetter: (params) =>
            Math.trunc(params.data.totalCashlessAmountPaise) / 100,
          valueFormatter: (params) => this.formatCurrencyV2(params),
        },
        {
          headerName: "Paid",
          field: "totalCashPaidAmountPaise",
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
          valueGetter: (params) =>
            Math.trunc(params.data.totalCashPaidAmountPaise) / 100,
          valueFormatter: (params) => this.formatCurrencyV2(params),
        },
        {
          headerName: "Panel",
          field: "chosenPanelName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
      ],
    },
  ];

  sxBookingRegisterReportColumnDefs = [
    // {
    // headerName: "Patient",
    // children: [
    {
      headerName: "Doctor Name",
      field: "surgeonName",
      filter: "agMultiColumnFilter",
      enableRowGroup: true,
      enablePivot: true,

      floatingFilter: true,
      valueFormatter: (params) => this.formatText(params.value) || "",
    },
    {
      headerName: "PID / Name of the Patient / Address",
      field: "",
      filter: "agMultiColumnFilter",
      enableRowGroup: true,
      enablePivot: true,
      floatingFilter: true,
      valueGetter: (params) => {
        if (!params.data) return "";
        return `${params.data.patientGenericPid} / ${params.data.patientName} / ${params.data.patientAddress}`;
      },
    },
    // {
    //   headerName: "Patient Phone",
    //   field: "patientPhone",
    //   filter: "agMultiColumnFilter",
    //   enableRowGroup: true,
    //   enablePivot: true,
    //   floatingFilter: true,
    //   valueFormatter: (params) => this.formatText(params.value),
    // },
    {
      headerName: "Patient Age",
      field: "patientDob",
      filter: "agMultiColumnFilter",
      enableRowGroup: true,
      enablePivot: true,
      floatingFilter: true,
      valueGetter: (params) =>
        params?.data?.patientDob ? niceAge(params?.data?.patientDob) : "",
    },
    {
      headerName: "Patient Sex",
      field: "patientSex",
      filter: "agMultiColumnFilter",
      enableRowGroup: true,
      enablePivot: true,
      floatingFilter: true,
      valueFormatter: (params) => this.formatText(params.value) || "",
    },
    {
      headerName: "Eye",
      field: "eye",
      filter: "agMultiColumnFilter",
      enableRowGroup: true,
      enablePivot: true,

      floatingFilter: true,
      valueFormatter: (params) => this.formatText(params.value) || "",
    },
    {
      headerName: "Eye Diet",
      field: "diet",
      filter: "agMultiColumnFilter",
      enableRowGroup: true,
      enablePivot: true,
      floatingFilter: true,
      valueFormatter: (params) => this.formatText(params.value) || "",
    },

    {
      headerName: "Special Note",
      field: "bookingRemarks",
      filter: "agMultiColumnFilter",
      enableRowGroup: true,
      enablePivot: true,
      floatingFilter: true,
      valueFormatter: (params) => this.formatText(params.value) || "",
    },
    {
      headerName: "Lens",
      field: "consumedItems",
      filter: "agMultiColumnFilter",
      enableRowGroup: true,
      enablePivot: true,
      floatingFilter: true,
      valueFormatter: (params) => {
        if (!params.value || !Array.isArray(params.value)) return "";
        const iolItems = params.value
          .filter((item) => item.itemCategory === "IOL")
          .map((item) => this.formatText(item.itemName));
        return iolItems.join(", ");
      },
      filterParams: {
        comparator: function (filterDates, cellValue) {
          let date = new Date(cellValue);
          let isPast = isInPastDateStrict(date, filterDates);
          let isFuture = isInFutureDateStrict(date, filterDates);
          if (isPast) {
            return -1;
          } else if (isFuture) {
            return 1;
          } else {
            return 0;
          }
        },
      },
    },

    {
      headerName: "Surgery",
      valueGetter: (params) => this.niceSxString(params) || "",
      filter: "agMultiColumnFilter",
      enableRowGroup: true,
      enablePivot: true,
      floatingFilter: true,
    },
    {
      headerName: "Site",
      field: "site",
      filter: "agMultiColumnFilter",
      enableRowGroup: true,
      enablePivot: true,

      floatingFilter: true,
      valueFormatter: (params) => this.formatText(params.value) || "",
    },
    {
      headerName: "Time",
      field: "time",
      filter: "agDateColumnFilter",
      enableRowGroup: true,
      enablePivot: true,
      floatingFilter: true,
      chartDataType: "time",
      valueGetter: (params) => niceDateTime(params.data.time),
      valueFormatter: (params) => niceDateTime(params.value),
      filterParams: {
        comparator: function (filterDates, cellValue) {
          let date = new Date(cellValue);
          let isPast = isInPastDateStrict(date, filterDates);
          let isFuture = isInFutureDateStrict(date, filterDates);
          if (isPast) {
            return -1;
          } else if (isFuture) {
            return 1;
          } else {
            return 0;
          }
        },
      },
    },
    {
      headerName: "Signature",
      field: "",
      filter: "agDateColumnFilter",
      enableRowGroup: true,
      enablePivot: true,
    },
  ];

  sxPaymentColumnDefs = [
    {
      headerName: "Patient",
      children: [
        {
          headerName: "Patient Name",
          field: "patientName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.patientName;
          },
        },
        {
          headerName: "Patient ID",
          field: "patientGenericPid",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
        },
        {
          headerName: "Patient Phone",
          field: "patientPhone",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.patientPhone.toString();
          },
        },
      ],
    },

    {
      headerName: "Surgery Details",
      children: [
        {
          headerName: "Surgeon",
          field: "surgeonName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.surgeonName;
          },
        },
        {
          headerName: "Time",
          field: "time",
          filter: "agDateColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          chartDataType: "time",
          valueGetter: (params) => {
            if (!params.data) return "";
            return niceDateTime(params.data.time);
          },
          valueFormatter: (params) => niceDateTime(params.value),
          filterParams: {
            comparator: function (filterDates, cellValue) {
              let date = new Date(cellValue);
              let isPast = isInPastDateStrict(date, filterDates);
              let isFuture = isInFutureDateStrict(date, filterDates);
              if (isPast) {
                return -1;
              } else if (isFuture) {
                return 1;
              } else {
                return 0;
              }
            },
          },
        },
        {
          headerName: "Site",
          field: "site",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.site;
          },
        },
        {
          headerName: "Eye",
          field: "eye",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.eye;
          },
        },
        {
          headerName: "Surgery",
          // valueGetter: (params) => this.niceSxString(params),
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return this.niceSxString(params);
          },
        },

        {
          headerName: "Lifecycle",
          field: "lifecycle",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.lifecycle;
          },
        },
      ],
    },

    {
      headerName: "Payment Details",
      children: [
        {
          headerName: "Bill Amount",
          field: "totalBillAmountPaise",
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
          valueGetter: (params) =>
            Math.trunc(params.data.totalBillAmountPaise) / 100,
          valueFormatter: (params) => this.formatCurrencyV2(params),
        },
        {
          headerName: "Cashless",
          field: "totalCashlessAmountPaise",
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
          valueGetter: (params) =>
            Math.trunc(params.data.totalCashlessAmountPaise) / 100,
          valueFormatter: (params) => this.formatCurrencyV2(params),
        },
        {
          headerName: "Total Paid",
          field: "paymentEvents.amountPaise",
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
          valueGetter: (params) =>
            Math.trunc(params.data.paymentEvents.amountPaise) / 100,
          valueFormatter: (params) => this.formatCurrencyV2(params),
        },
        {
          headerName: "Panel",
          field: "chosenPanelName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Transaction Type",
          field: "paymentEvents.transactionType",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.paymentEvents.transactionType;
          },
        },
        {
          headerName: "Transaction Mode",
          field: "paymentEvents.paymentMode",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueGetter: (params) => {
            if (!params.data) return "";
            return params.data.paymentEvents.paymentMode;
          },
          valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Transaction Reference",
          field: "paymentEvents.paymentRef",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },

        {
          headerName: "Transaction Time",
          field: "paymentEvents.ts",
          filter: "agDateColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          chartDataType: "time",
          valueGetter: (params) => niceDateTime(params.data.paymentEvents.ts),
          valueFormatter: (params) => niceDateTime(params.value),
          filterParams: {
            comparator: function (filterDates, cellValue) {
              let date = new Date(cellValue);
              let isPast = isInPastDateStrict(date, filterDates);
              let isFuture = isInFutureDateStrict(date, filterDates);
              if (isPast) {
                return -1;
              } else if (isFuture) {
                return 1;
              } else {
                return 0;
              }
            },
          },
        },
        {
          headerName: "Created By",
          field: "createdByName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Billed By",
          field: "paymentEvents.createdBy",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Billed At",
          field: "paymentEvents.ts",
          filter: "agDateColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          chartDataType: "time",
          valueGetter: (params) => niceDateTime(params.data.paymentEvents.ts),
          valueFormatter: (params) => niceDateTime(params.value),
          filterParams: {
            comparator: function (filterDates, cellValue) {
              let date = new Date(cellValue);
              let isPast = isInPastDateStrict(date, filterDates);
              let isFuture = isInFutureDateStrict(date, filterDates);
              if (isPast) {
                return -1;
              } else if (isFuture) {
                return 1;
              } else {
                return 0;
              }
            },
          },
        },
      ],
    },
  ];
  sxInsuranceColumnDefs = [
    {
      headerName: "Patient",
      children: [
        {
          headerName: "Patient Name",
          field: "patientName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Patient ID",
          field: "patientGenericPid",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
        },
        {
          headerName: "Patient Phone",
          field: "patientPhone",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
      ],
    },

    {
      headerName: "Surgery Details",
      children: [
        {
          headerName: "Surgeon",
          field: "surgeonName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Time",
          field: "time",
          filter: "agDateColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          chartDataType: "time",
          valueGetter: (params) => niceDateTime(params.data.time),
          valueFormatter: (params) => niceDateTime(params.value),
          filterParams: {
            comparator: function (filterDates, cellValue) {
              let date = new Date(cellValue);
              let isPast = isInPastDateStrict(date, filterDates);
              let isFuture = isInFutureDateStrict(date, filterDates);
              if (isPast) {
                return -1;
              } else if (isFuture) {
                return 1;
              } else {
                return 0;
              }
            },
          },
        },
        {
          headerName: "Site",
          field: "site",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Eye",
          field: "eye",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Surgery",
          valueGetter: (params) => this.niceSxString(params),
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
        },

        {
          headerName: "Lifecycle",
          field: "lifecycle",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
      ],
    },

    {
      headerName: "Payment Details",
      children: [
        {
          headerName: "Bill Amount",
          field: "totalBillAmountPaise",
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
          valueGetter: (params) =>
            Math.trunc(params.data.totalBillAmountPaise) / 100,
          valueFormatter: (params) => this.formatCurrencyV2(params),
        },
        {
          headerName: "Cashless",
          field: "totalCashlessAmountPaise",
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
          valueGetter: (params) =>
            Math.trunc(params.data.totalCashlessAmountPaise) / 100,
          valueFormatter: (params) => this.formatCurrencyV2(params),
        },
        {
          headerName: "Total Paid",
          field: "totalCashPaidAmountPaise",
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
          valueGetter: (params) =>
            Math.trunc(params.data.totalCashPaidAmountPaise) / 100,
          valueFormatter: (params) => this.formatCurrencyV2(params),
        },
        {
          headerName: "Panel",
          field: "chosenPanelName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Authorization Type",
          field: "panelAuthorizationsHistory.typeOfAuthorization",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },

        {
          headerName: "Authorization Reference",
          field: "panelAuthorizationsHistory.authorizationRef",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Amount",
          field: "panelAuthorizationsHistory.amountPaise",
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
          valueGetter: (params) =>
            Math.trunc(params.data.panelAuthorizationsHistory.amountPaise) /
            100,
          valueFormatter: (params) => this.formatCurrencyV2(params),
        },
        {
          headerName: "Transaction Time",
          field: "panelAuthorizationsHistory.ts",
          filter: "agDateColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          chartDataType: "time",
          valueGetter: (params) =>
            niceDateTime(params.data.panelAuthorizationsHistory.ts),
          valueFormatter: (params) => niceDateTime(params.value),
          filterParams: {
            comparator: function (filterDates, cellValue) {
              let date = new Date(cellValue);
              let isPast = isInPastDateStrict(date, filterDates);
              let isFuture = isInFutureDateStrict(date, filterDates);
              if (isPast) {
                return -1;
              } else if (isFuture) {
                return 1;
              } else {
                return 0;
              }
            },
          },
        },
      ],
    },
  ];
  sxItemConsumptionColumnDefs = [
    {
      headerName: "Patient",
      children: [
        {
          headerName: "Patient Name",
          field: "patientName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value) || "",
        },
        {
          headerName: "Patient ID",
          field: "patientGenericPid",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
        },
        {
          headerName: "Patient Phone",
          field: "patientPhone",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value) || "",
        },
      ],
    },
    {
      headerName: "Surgery Details",
      children: [
        {
          headerName: "Surgeon",
          field: "surgeonName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value) || "",
        },
        {
          headerName: "Time",
          field: "time",
          filter: "agDateColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          chartDataType: "time",
          valueGetter: (params) =>
            params?.data ? niceDateTime(params.data.time) : "",
          valueFormatter: (params) => niceDateTime(params.value) || "",
          filterParams: {
            comparator: function (filterDates, cellValue) {
              let date = new Date(cellValue);
              let isPast = isInPastDateStrict(date, filterDates);
              let isFuture = isInFutureDateStrict(date, filterDates);
              if (isPast) {
                return -1;
              } else if (isFuture) {
                return 1;
              } else {
                return 0;
              }
            },
          },
        },
        {
          headerName: "Site",
          field: "site",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value) || "",
        },
        {
          headerName: "Eye",
          field: "eye",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value) || "",
        },
        {
          headerName: "Surgery",
          valueGetter: (params) => this.niceSxString(params) || "",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
        },

        {
          headerName: "Lifecycle",
          field: "lifecycle",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value) || "",
        },
      ],
    },
    {
      headerName: "Payment Details",
      children: [
        {
          headerName: "Bill Amount",
          field: "totalBillAmountPaise",
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
          valueGetter: (params) =>
            Math.trunc(params.data.totalBillAmountPaise) / 100,
          valueFormatter: (params) => this.formatCurrencyV2(params),
        },
        {
          headerName: "Cashless",
          field: "totalCashlessAmountPaise",
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
          valueGetter: (params) =>
            Math.trunc(params.data.totalCashlessAmountPaise) / 100,
          valueFormatter: (params) => this.formatCurrencyV2(params),
        },
        {
          headerName: "Total Paid",
          field: "totalCashPaidAmountPaise",
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
          valueGetter: (params) =>
            Math.trunc(params.data.totalCashPaidAmountPaise) / 100,
          valueFormatter: (params) => this.formatCurrencyV2(params),
        },
        {
          headerName: "Panel",
          field: "chosenPanelName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,

          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
      ],
    },
    {
      headerName: "Item Details",
      children: [
        {
          headerName: "Item Name",
          field: "consumedItems.itemName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
        },
        {
          headerName: "Item Entity",
          field: "consumedItems.itemEntityName",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
        },
        {
          headerName: "Item Variant",
          field: "consumedItems.itemNameSuffix",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
        },
        {
          headerName: "Item Category",
          field: "consumedItems.itemCategory",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
      ],
    },
    {
      headerName: "Consumption Details",
      children: [
        {
          headerName: "Serial/Batch #",
          field: "consumedItems.inventoryDetails.serialNumber",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
        },
        {
          headerName: "Expiry Date",
          valueGetter: (params) => this.renderExpiry(params),
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          filterParams: {
            comparator: function (filterDates, cellValue) {
              let date = new Date(cellValue);
              let isPast = isInPastDateStrict(date, filterDates);
              let isFuture = isInFutureDateStrict(date, filterDates);
              if (isPast) {
                return -1;
              } else if (isFuture) {
                return 1;
              } else {
                return 0;
              }
            },
          },
        },
        {
          headerName: "Perishable",
          field: "consumedItems.itemHasExpiry",
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          valueFormatter: (params) => this.formatText(params.value),
        },
        {
          headerName: "Quantity (Human Readable)",
          valueGetter: (params) => this.renderQuantityNice(params),
          filter: "agMultiColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
        },
        {
          headerName: "Quantity (Numeric)",
          valueGetter: (params) => this.renderQuantityNumeric(params),
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
        },
        {
          headerName: "Quantity (Whole)",
          valueGetter: (params) => this.renderQuantityWhole(params),
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
        },
        {
          headerName: "Quantity (Fractional)",
          valueGetter: (params) => this.renderQuantityFractional(params),
          filter: "agNumberColumnFilter",
          enableRowGroup: true,
          enablePivot: true,
          floatingFilter: true,
          aggFunc: "sum",
        },
      ],
    },
  ];
  niceSxString = (params) => {
    let ll = params?.data?.lineItems;
    let ll2 = _.filter(ll, (each) => each.lineItemType === "SX").filter(
      Boolean
    );

    return ll2.map((each) => each.entityName).join(" , ");
  };
  niceItemsUsedString = (params) => {
    let ll = params?.data?.itemsNeededForSurgery;

    if (ll && ll.length > 0) {
      return ll?.map((each) => each.entityName).join(" , ");
    } else {
      return;
    }
  };
  formatText = (params) => {
    if (params === "NA") {
      return "";
    }
    return _.startCase(_.lowerCase(params));
  };
  format2Decimal = (params) => {
    return Number(params).toFixed(2) + " years";
  };
  formatCurrency = (params) => {
    let num = Number(params.value / 100);
    return num.toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  };

  formatCurrencyV2 = (params) => {
    const num = params.value;
    return num.toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  };
  renderExpiry = (params) => {
    if (params.data?.consumedItems?.itemHasExpiry) {
      return new Date(params.data.consumedItems.inventoryDetails.expiresOn);
    } else {
      return new Date("2100");
    }
  };
  renderQuantityNumeric = (params) => {
    return (
      params.data.consumedItems.inventoryDetails.quantity /
      params.data.consumedItems.inventoryDetails.subunitOfConsumption
    );
  };
  renderQuantityWhole = (params) => {
    return Math.floor(
      params.data.consumedItems.inventoryDetails.quantity /
        params.data.consumedItems.inventoryDetails.subunitOfConsumption
    );
  };
  renderQuantityFractional = (params) => {
    return (
      params.data.consumedItems.inventoryDetails.quantity %
      params.data.consumedItems.inventoryDetails.subunitOfConsumption
    );
  };

  renderQuantityNice = (params) => {
    let qty = params.data?.consumedItems?.inventoryDetails?.quantity;
    let sub =
      params.data?.consumedItems?.inventoryDetails?.subunitOfConsumption;
    let unit = params.data?.consumedItems?.itemUnitName;
    let subunit = params.data?.consumedItems?.itemSubunitName;
    let integerQty = Math.floor(qty / sub);
    let fracQty = qty % sub;
    let str = `${integerQty} ${unit}`;
    if (fracQty) {
      str = str + ` ${fracQty} ${subunit}`;
    }
    return str;
  };
  columnDefs = () => {
    if (this.props.entityType === "sxBookingReport") {
      return (
        <MasterGrid
          typeOfGrid="Sx Booking Report"
          columnDefs={this.sxBookingReportColumnDefs}
          key={nanoid()}
          loadedItems={this.props.loadedItems}
        />
      );
    }
    if (this.props.entityType === "sxBookingRegisterReport") {
      return (
        <MasterGrid
          typeOfGrid="Sx Booking Register Report"
          columnDefs={this.sxBookingRegisterReportColumnDefs}
          key={nanoid()}
          loadedItems={this.props.loadedItems}
        />
      );
    }
    if (this.props.entityType === "sxPaymentReport") {
      return (
        <MasterGrid
          typeOfGrid="Sx Payment Report"
          columnDefs={this.sxPaymentColumnDefs}
          key={nanoid()}
          loadedItems={this.props.loadedItems}
        />
      );
    }
    if (this.props.entityType === "sxInsuranceReport") {
      return (
        <MasterGrid
          typeOfGrid="Sx Insurance Report"
          columnDefs={this.sxInsuranceColumnDefs}
          key={nanoid()}
          loadedItems={this.props.loadedItems}
        />
      );
    }
    if (this.props.entityType === "sxItemConsumptionReport") {
      return (
        <MasterGrid
          typeOfGrid="Sx Item Consumption Report"
          columnDefs={this.sxItemConsumptionColumnDefs}
          key={nanoid()}
          loadedItems={this.props.loadedItems}
        />
      );
    }
  };
  render() {
    return <div>{this.columnDefs()}</div>;
  }
}

export default inject("authStore")(observer(ColumnDefs));
